import React from 'react';
import { CheckCircle } from '@mui/icons-material';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    DialogContentText,
    Box,
    CircularProgress,
} from '@mui/material';

const SuccessDialog = ({ open, onOpenChange, onDeploy, onDashboard, isDeploying }) => {
    return (
        <Dialog open={open} onClose={onOpenChange}>
            <DialogContent sx={{ maxWidth: { sm: 448 } }}>
                <DialogTitle sx={{ textAlign: 'center' }}>Position Saved Successfully!</DialogTitle>
                <DialogContentText sx={{ textAlign: 'center' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                        <CheckCircle sx={{ fontSize: 64, color: 'success.main' }} />
                    </Box>
                    <Box sx={{ mt: 1 }}>
                        Your position has been saved successfully. Would you like to deploy it now?
                    </Box>
                </DialogContentText>
                <DialogActions
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: { sm: 'center' },
                        gap: { sm: 1 },
                        mt: 2,
                    }}
                >
                    <Button
                        type="button"
                        variant="outlined"
                        onClick={onDashboard}
                        sx={{
                            width: { xs: '100%', sm: 'auto' },
                            mb: { xs: 1, sm: 0 },
                        }}
                    >
                        No, go to dashboard
                    </Button>
                    <Button
                        type="button"
                        sx={{
                            bgcolor: '#ED7342',
                            '&:hover': {
                                bgcolor: '#ED7342',
                                opacity: 0.9,
                            },
                            width: { xs: '100%', sm: 'auto' },
                            mt: { xs: 1, sm: 0 },
                        }}
                        onClick={onDeploy}
                        disabled={isDeploying}
                    >
                        {isDeploying ? (
                            <>
                                Deploying...
                                <CircularProgress size={16} sx={{ ml: 1, color: 'white' }} />
                            </>
                        ) : (
                            'Yes, deploy now'
                        )}
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default SuccessDialog;
